/**
 * ageTone: la banda D (7;0–10;11) recibe textos y mascota menos infantiles
 * (master §2.2, `ageTone: BIG_KID`). No es una traducción distinta: es el mismo
 * mensaje con otro registro, así que se resuelve como sufijo de clave i18n.
 *
 * Puro y testeable: solo las claves listadas en CON_TONO tienen variante, y para
 * el resto se devuelve la clave original (no existe `.bigkid` que resolver).
 */
import type { BandaEtaria } from "../api/types.js";
import type { MessageKey } from "../i18n/index.js";

export type AgeTone = "KID" | "BIG_KID";

export function tonoDeBanda(banda: BandaEtaria): AgeTone {
  return banda === "D" ? "BIG_KID" : "KID";
}

/** Claves con variante `.bigkid` en el diccionario. */
const CON_TONO: ReadonlySet<string> = new Set<MessageKey>([
  "eval.peff.consigna.F1",
  "eval.peff.consigna.F2",
  "eval.peff.consigna.F3",
  "eval.peff.consigna.F4",
  "eval.peff.consigna.PSF1",
  "eval.peff.consigna.PSF2",
  "eval.peff.consigna.start",
  "eval.peff.item.noEvoca",
]);

export function claveConTono(key: MessageKey, tono: AgeTone): MessageKey {
  if (tono !== "BIG_KID" || !CON_TONO.has(key)) return key;
  return `${key}.bigkid` as MessageKey;
}
